<template>
  <div>
    <b-modal
        scrollable
      id="add-employee-payment"
      ref="modal"
      header-class="headerModal"
      centered
      :title="`${$t('AddPaymentFor')} ${user.firstName} ${user.lastName} `"
      size="l"
      hide-footer
      @hide="onCancel"
    >
      <b-form>
        <b-form>
          <div style="display: flex;">
            <b-form-group
              id="input-group-8"
              :label="$t('EditY')"
              style="width:100%;  margin-right: 10px;"
              label-for="input-25"
            >
              <vue-select
                id="input-5"
                v-model="form.year"
                required
                :options="yearsArray"
                :placeholder="$t('Select')"
                aria-describedby="input-1-live-feedback"
              />
            </b-form-group>
            <b-form-group
              id="input-group-8"
              :label="$t('Month')"
              style="width:100%"
              label-for="input-25"
            >
              <vue-select
                id="input-5"
                v-model="monthh"
                :reduce="(e) => e.value"
                required
                :options="remainingMonths"
                label="name"
                :placeholder="$t('Select')"
                aria-describedby="input-1-live-feedback"
              />
            </b-form-group>
          </div>
          <div style="display: flex;">
            <b-form-group
              id="input-group-8"
              :label="$t('Amount')"
              style="width:100%; margin-right: 10px"
              label-for="input-25"
            >
              <b-form-input
                id="input-1"
                v-model="form.amount"
                type="number"
              />
            </b-form-group>
            <b-form-group
              id="input-group-8"
              :label="$t('Account')"
              style="width:100%"
              label-for="input-25"
            >
              <vue-select
                id="input-1"
                v-model="form.accountId"
                :reduce="(e) => e.accountId"
                label="name"
                :placeholder="$t('Select')"
                :options="getAccountDetails"
              />
            </b-form-group>
          </div>
          <b-form-group
            id="input-group-8"
            :label="$t('Currency')"
            style="width:100%"
            label-for="input-25"
          >
            <vue-select
              v-model="form.currency"
              dropup
              required
              :options="currencies"
              style="width: 100%"
            />
          </b-form-group>
          <b-form-group
            id="input-group-8"
            :label="$t('Notes')"
            style="width:100%"
            label-for="input-25"
          >
            <b-form-textarea
              id="textarea"
              v-model="form.notes"
              :placeholder="$t('WriteHere')"
              rows="3"
              max-rows="3"
            />
          </b-form-group>
        </b-form>
      </b-form>
      <div class="buttonsEverywhere">
        <b-button
          type="button"
          variant="none"
          class="buttonSubmit"
          @click="onSubmit"
        >
          {{ $t("Submit") }}
        </b-button>
        <b-button
          type="button"
          variant="danger"
          class="buttonCancel"
          style="margin-right: 15px"
          @click="onCancel"
        >
          {{ $t("Cancel") }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment'

export default {
  components: {},
  // eslint-disable-next-line vue/require-prop-types
  props: ['user', 'usedMonths'],
  data() {
    return {
      yearsArray: [2020, 2021, 2022, 2023],
      rate: null,
      currencies: ['€', '$', 'CHF'],
      months: [
        {
          value: 1,
          name: this.$t('January'),
        },
        {
          value: 2,
          name: this.$t('February'),
        },
        {
          value: 3,
          name: this.$t('March'),
        },
        {
          value: 4,
          name: this.$t('April'),
        },
        {
          value: 5,
          name: this.$t('May'),
        },
        {
          value: 6,
          name: this.$t('June'),
        },
        {
          value: 7,
          name: this.$t('July'),
        },
        {
          value: 8,
          name: this.$t('August'),
        },
        {
          value: 9,
          name: this.$t('September'),
        },
        {
          value: 10,
          name: this.$t('October'),
        },
        {
          value: 11,
          name: this.$t('November'),
        },
        {
          value: 12,
          name: this.$t('December'),
        },
      ],
      selectedYear: null,
      monthh: null,
      text: null,
      form: {
        userId: this.user.userId,
        year: moment().year(),
        month: moment().month() + 1,
        amount: null,
        notes: null,
        accountId: null,
        currency: null,
      },

    };
  },
  computed: {
    ...mapGetters(['getfreeTeamLeaders', 'getVacationRequests', 'getAccountDetails']),
    remainingMonths() {
      return this.months.filter((month) => { return !this.usedMonths.includes(month.value) });
    },

  },
  watch: {
    // rate(value) {
    //   if (value == 1) {
    //     this.form.amount = 'Bad'
    //   } else if (value == 2 || value == 3) {
    //     this.form.amount = 'Good'
    //   } else if (value == 4) {
    //     this.form.amount = 'Better'
    //   } else if (value == 5) {
    //     this.form.amount = 'Best'
    //   }
    // },
    'user.userId': {
      handler(value) {
        this.form.userId = value
      },
    },
    user(value) {
      this.form.userId = value.userId
    },
    monthh(value) {
      this.form.month = value
    },
  },
  methods: {
    ...mapActions(['loadUsersFullNamesById', 'cancelVacation', 'accountDetails']),
    onSubmit() {
      this.$emit('submit', this.form);
      this.$refs.modal.hide()
      this.onReset();
    },
    onCancel() {
      this.$refs.modal.hide();
      this.onReset();
    },
    onReset() {
      this.form.notes = '';
      this.rate = 0;
      this.monthh = '';
      this.form.year = moment().year();
      this.form.month = moment().month()
      this.form.amount = ''
      this.accountId = null
    },
  },
};
</script>

<style lang="scss" scoped>
form {
  display: grid;
  // grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.form {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.form2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.flex-form {
  display: flex;
  flex-direction: column;
}
.uploadButtons {
  display: flex;
  align-items: flex-end;
}
</style>
